// @ts-nocheck

export const localeCodes =  [
  "en",
  "fr",
  "nl",
  "de",
  "es",
  "it",
  "pl",
  "ko",
  "uk"
]
export const localeLoaders = {
  en: [
    {
      key: "locale_en_46json_5ef3bb15",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_en_46json_20fb6258",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_en_46json_b7a6725b",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_en_46json_2d7f2c26",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_en_46json_0f89c35a",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_en_46json_509aac86",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_en_46json_2842bad5",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_en_46json_50a14a69",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_en_46json_2c89b3ff",
      load: () => Promise.resolve({}),
      cache: true
    }
  ],
  fr: [
    {
      key: "locale_fr_46json_5521cbe2",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_fr_46json_987ea925",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_fr_46json_05e380d1",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_fr_46json_ef82c5df",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_fr_46json_eb4f112c",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_fr_46json_f76accbe",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_fr_46json_7b06716d",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_fr_46json_c0ed8b12",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_fr_46json_209ea2a0",
      load: () => Promise.resolve({}),
      cache: true
    }
  ],
  nl: [
    {
      key: "locale_nl_46json_47c8311a",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_nl_46json_a1bb1c7b",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_nl_46json_e3147e37",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_nl_46json_b0c28d63",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_nl_46json_9dc2ae01",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_nl_46json_7ec2a9ad",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_nl_46json_9d3a41b5",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_nl_46json_7e5ffc32",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_nl_46json_8f3e30a7",
      load: () => Promise.resolve({}),
      cache: true
    }
  ],
  de: [
    {
      key: "locale_de_46json_edf0306a",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_de_46json_f0f14150",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_de_46json_708007d2",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_de_46json_5179cdcd",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_de_46json_e3a7ba04",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_de_46json_17e43d3e",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_de_46json_3b69aa1b",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_de_46json_3e18811b",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_de_46json_3bd1f143",
      load: () => Promise.resolve({}),
      cache: true
    }
  ],
  es: [
    {
      key: "locale_es_46json_42a98a00",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_es_46json_6a9d1635",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_es_46json_41a5aa42",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_es_46json_5be06087",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_es_46json_24cfc1b0",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_es_46json_2028a926",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_es_46json_2b7ec610",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_es_46json_edca285f",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_es_46json_5a043d44",
      load: () => Promise.resolve({}),
      cache: true
    }
  ],
  it: [
    {
      key: "locale_it_46json_332e4db9",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_it_46json_58545d44",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_it_46json_4096255b",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_it_46json_53adcc03",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_it_46json_b69ec30d",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_it_46json_3676672a",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_it_46json_c67d322d",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_it_46json_30eeaa23",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_it_46json_623acada",
      load: () => Promise.resolve({}),
      cache: true
    }
  ],
  pl: [
    {
      key: "locale_pl_46json_a66d43e8",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_pl_46json_b42cde0a",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_pl_46json_ebe178e8",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_pl_46json_0038c3d9",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_pl_46json_d4f7fe5f",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_pl_46json_4ec934f5",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_pl_46json_fedcd01d",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_pl_46json_c5b257b0",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_pl_46json_8e205c4d",
      load: () => Promise.resolve({}),
      cache: true
    }
  ],
  ko: [
    {
      key: "locale_ko_46json_37d42559",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_ko_46json_d567aa51",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_ko_46json_50b7b9b0",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_ko_46json_00440b0c",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_ko_46json_c924e47d",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_ko_46json_6d420610",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_ko_46json_11e1857e",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_ko_46json_f1a3ee13",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_ko_46json_37eae153",
      load: () => Promise.resolve({}),
      cache: true
    }
  ],
  uk: [
    {
      key: "locale_uk_46json_97283177",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_uk_46json_0139bb06",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_uk_46json_11e5505c",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_uk_46json_2db93941",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_uk_46json_80620973",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_uk_46json_814f039d",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_uk_46json_52c69af6",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_uk_46json_5f0c49ba",
      load: () => Promise.resolve({}),
      cache: true
    },
    {
      key: "locale_uk_46json_95158ab9",
      load: () => Promise.resolve({}),
      cache: true
    }
  ]
}
export const vueI18nConfigs = [
  () => import("#nuxt-i18n/1234d269" /* webpackChunkName: "config_i18n_46config_46ts_1234d269" */)
]
export const normalizedLocales = [
  {
    code: "en",
    name: "English",
    language: undefined,
    domains: [],
    defaultForDomains: []
  },
  {
    code: "fr",
    name: "Français",
    language: undefined,
    domains: [],
    defaultForDomains: []
  },
  {
    code: "nl",
    name: "Nederlands",
    language: undefined,
    domains: [],
    defaultForDomains: []
  },
  {
    code: "de",
    name: "Deutsch",
    language: undefined,
    domains: [],
    defaultForDomains: []
  },
  {
    code: "es",
    name: "Español",
    language: undefined,
    domains: [],
    defaultForDomains: []
  },
  {
    code: "it",
    name: "Italiano",
    language: undefined,
    domains: [],
    defaultForDomains: []
  },
  {
    code: "pl",
    name: "Polski (Beta)",
    language: undefined,
    domains: [],
    defaultForDomains: []
  },
  {
    code: "ko",
    name: "한국어",
    language: undefined,
    domains: [],
    defaultForDomains: []
  },
  {
    code: "uk",
    name: "Українська",
    language: undefined,
    domains: [],
    defaultForDomains: []
  }
]

